import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette } from '../../../../theme';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    tabItem: {
      fontSize: 16,
      textTransform: 'uppercase',
      color: colorsPalette.white,
      padding: '5px 0',
      fontWeight: 'bold',
      position: 'relative',
      cursor: 'pointer',

      '&:after': {
        content: '""',
        position: 'absolute',
        bottom: 0,
        height: 3,
        width: '0%',
        left: 0,
        backgroundColor: theme.palette.primary.main,
        transition: '0.5s ease all .3s',
      },
      '&:hover': {
        '&:after': {
          width: '99%',
          transition: '0.3s ease all',
        },
      },
      [theme.breakpoints.up('sm')]: {
        padding: '10px 0',
      },
    },
    active: {
      '&:after': {
        width: '99%',
      },
    },
  }),
);

export default useStyles;
